import {   
  GET_CITIES,   
  } from '../Type';
  
  export const getCities = (data) => {
    return {
      type: GET_CITIES,
      data: data
    }
  }